import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Id, PagedParams, PagedResponse, getQueryKey, invalidateAfterDelete } from '@feature/utils';

import * as api from './AwardApi';
import { Award, AwardRequest } from './AwardTypes';

const awardKey = getQueryKey('award');

export function getAwardPagedOptions(params: PagedParams): UseSuspenseQueryOptions<PagedResponse<Award>> {
  return {
    queryKey: awardKey.paged(params),
    queryFn: () => api.getPaged(params),
  };
}

export function getAwardOptions(awardId: Id): UseSuspenseQueryOptions<Award> {
  return {
    queryKey: awardKey.one(awardId),
    queryFn: () => api.get(awardId),
  };
}

export function useAwardEdit(awardId: Id) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: AwardRequest) => api.edit(awardId, request),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: awardKey.root(),
      }),
  });
}

export function useAwardCreate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: AwardRequest) => api.create(request),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: awardKey.root(),
      }),
  });
}

export function useAwardDelete(awardId: Id) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => api.deleteById(awardId),
    onSuccess: () => invalidateAfterDelete(queryClient, awardKey, awardId),
  });
}
